import React, { Component } from "react";
import { Table, Progress } from "semantic-ui-react";

const header_labels = ["Rank", "Name", "Total Apps Read", "This Round"];

class Dashboard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let title_row = (
      <Table.Row>
        <Table.HeaderCell textAlign="center" colSpan="4">
          <h2>Leaderboard</h2>
        </Table.HeaderCell>
      </Table.Row>
    );
    let headers = header_labels.map((item) => (
      <Table.HeaderCell key={item}>{item}</Table.HeaderCell>
    ));
    let header_row = <Table.Row>{headers}</Table.Row>;
    let cells = [];
    for (var i = 0; i < this.props.data.leaderboard.length; i++) {
      let temp_data = this.props.data.leaderboard[i];
      cells.push(
        <Table.Row verticalAlign="middle">
          <Table.Cell>{i + 1}</Table.Cell>
          <Table.Cell>{temp_data.user}</Table.Cell>
          <Table.Cell>{temp_data.total_apps_read}</Table.Cell>
          <Table.Cell width={8}>
            {temp_data.total_apps_read} /{" "}
            {this.props.data.global_stats.grader_target}
            <Progress
              value={temp_data.total_apps_read}
              total={this.props.data.global_stats.grader_target}
              progress="percent"
              precision={0}
              indicating
              style={{ padding: 0 }}
            />
          </Table.Cell>
        </Table.Row>
      );
      if (temp_data.id === this.props.data.user.id) {
        this.props.getRank(i + 1);
      }
    }
    return (
      <Table compact textAlign="center" verticalAlign="middle" celled>
        <Table.Header>
          {title_row}
          {header_row}
        </Table.Header>

        <Table.Body>{cells}</Table.Body>
      </Table>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/Leaderboard.js